import PropTypes from 'prop-types'
import React from 'react'

const PermissionsOutlineIcon = ({
   className,
   color,
   width,
   height,
   strokeWidth
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <path
            d="M14,8l-2.172,2.172a4,4,0,0,1-5.656,0L6,10l4.929-4.929a7.072,7.072,0,0,1,10,0h0A7.074,7.074,0,0,1,22,13.7"
            fill="none"
            strokeMiterlimit="10"
         />
         <path
            d="M15.266,11.266l3.613,3.613a3,3,0,0,1,0,4.242l-1.636,1.636a6,6,0,0,1-8.486,0L3.071,15.071a7.072,7.072,0,0,1,0-10h0A7.048,7.048,0,0,1,8,3"
            fill="none"
            strokeMiterlimit="10"
         />
         <line
            x1="18.391"
            y1="19.609"
            x2="14.5"
            y2="15.719"
            fill="none"
            strokeMiterlimit="10"
         />
         <line
            x1="15.513"
            y1="21.965"
            x2="11.883"
            y2="18.335"
            fill="none"
            strokeMiterlimit="10"
         />
      </g>
   </svg>
)

PermissionsOutlineIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

PermissionsOutlineIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(PermissionsOutlineIcon)
